<template>
  <form-component>
    <form
      novalidate="novalidate"
      @submit.prevent="doSave"
    >
      <div class="form-row">
        <div class="col-12 col-md-6">
          <input-text
            id="first_name"
            v-model="first_name"
            v-validate="'required'"
            name="first_name"
            data-vv-name="first_name"
            data-vv-as="first name"
            label="First Name"
            type="text"
            required
            :error="errors.first('first_name')"
          />
        </div>
        <div class="col-12 col-md-6">
          <input-text
            id="last_name"
            v-model="last_name"
            v-validate="'required'"
            name="last_name"
            data-vv-name="last_name"
            data-vv-as="last name"
            label="Last Name"
            type="text"
            required
            :error="errors.first('last_name')"
          />
        </div>
      </div>

      <!-- <input-text
        id="password"
        v-model="password"
        v-validate="'required'"
        name="password"
        data-vv-name="password"
        data-vv-as="password"
        label="Password"
        type="password"
        required
        :error="errors.first('password')"
      />

      <input-text
        id="confirm"
        v-model="confirm"
        v-validate="'required'"
        name="confirm"
        data-vv-name="confirm"
        data-vv-as="confirm password"
        label="Confirm Password"
        type="password"
        required
        :error="errors.first('confirm')"
      /> -->

      <div class="form-row">
        <div class="col-12 col-md-6">
          <input-text
            id="phone"
            v-model="phone"
            name="phone"
            label="Phone Number"
            type="number"
          />
        </div>
        <div class="col-12 col-md-6">
          <input-text
            id="zip_code"
            v-model="zip_code"
            name="zip_code"            
            label="Zip Code"
            type="number"            
          />
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <input-text
            id="email"
            v-model="email"
            name="email"
            label="Email Address"
            type="email"
            disabled
          />
        </div>
      </div>


      <button
        v-if="showSaveButton"
        type="submit"
        class="btn btn--primary mt-4"
      >
        <processing-text :prc="saving">
          Save Changes
        </processing-text>
      </button>
    </form>
    <hr>
    <div class="form-row">
      <div class="col-12">
        <h3 style="text-align:left;">
          Profile Photo
        </h3>
        <div class="card mt-4 avatar-card">
          <div class="logo">
            <div v-if="avatarFileUrl">
              <img :src="avatarFileUrl">
            </div>
            <div
              v-else
              class="photo-preview"
              style="text-align:center;"
            >
              <div class="user-avatar" />
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary upload-btn"
            @click="addAvatarFile()"
          >
            <span v-if="savingAvatar">
              <font-awesome-icon
                :spin="true"
                :icon="['fas', 'spinner']"
                class="icon alt"
                style="margin-right: 7px;"
              />
            </span>
            <span v-else>
              <font-awesome-icon
                :icon="['fas', 'upload']"
              />
              Upload Image
            </span>
          </button>

          <input
            id="avatarFile"
            ref="avatarFilePicker"
            style="display:none;"
            type="file"
            name="avatarFile"
            @change="willAddAvatarFile"
          >
        </div>
      </div>
    </div>
  </form-component>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import ProcessingText from '@/components/ProcessingText.vue';
import InputText from '@/components/inputs/InputText.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'UserSettingsForm',
  components: {
    FormComponent,
    ProcessingText,
    InputText,
  },
  props: {
    onSave: {
      type: Function,
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      saving: false,
      savingAvatar: false,
      userClient: new UserClient(this.$http),

      id: 0,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      zip_code: '',

      // photo
      avatarFileUrl: '',
      avatarFile: null,
    };
  },
  mounted() {
    if (this.user) {
      this.reset(this.user);
    }
  },
  methods: {
    reset(user) {
      if (user) {
        this.id = user.id;
        this.first_name = user.first_name;
        this.last_name = user.last_name;
        this.email = user.email;
        this.phone = user.phone;
        this.zip_code = user.zip_code;
        this.avatarFileUrl = user.avatar_url || '';
      } else {
        this.id = 0;
        this.first_name = '';
        this.last_name = '';
        this.email = '';
        this.phone = '';
        this.zip_code = '';
        this.avatarFile = null;
        this.avatarFileUrl = '';
      }
      this.avatarFile = null;
    },
    // photo
    addAvatarFile() {
      this.$refs.avatarFilePicker.click();
    },
    async willAddAvatarFile(event) {
      const files = event.target.files || [];
      const avatarFile = files.length ? files[0] : null;

      if (avatarFile) {
        this.savingAvatar = true;

        try {
          const signed_url = await this.userClient.getUserAvatarUrl();
          await UserClient.saveFile(signed_url, avatarFile);

          const avatar_url = signed_url.split('?')[0] + `?dt=${new Date().getTime()}`;
          await this.userClient.editUser({
            avatar_url,
          });

          this.avatarFileUrl = avatar_url;

          // store the avatar url
          const user = this.$globals.user();
          user.avatar_url = avatar_url;
          this.$store.commit('setUser', user);
          this.$globals.activateTracking(user);

          this.savingAvatar = false;
        } catch (ex) {
          console.log(ex);
          this.$globals.showError('Failed to save file. Please try again!', ex);
          this.avatarFile = null;
          this.savingAvatar = false;
        }
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();

          const phone = this.phone.replace(/[^\d.]/g, '');

          this.saving = true;

          const {
            first_name,
            last_name,
            // email,
            zip_code,
          } = this;


          const data = {
            first_name,
            last_name,
            // email,
            zip_code,
            phone,
          };

          this.userClient.editUser(data).then(res => {
            this.saving = false;
            this.onSave(res);
            this.$globals.refreshUser();
          }).catch(ex => {
            this.saving = false;
            this.onSave(null, ex);
          });
        } else {
          // for outer save buttons pass back something to stop spinning
          this.$globals.scrollToFirstError(this.$validator);
          this.onSave(null, null);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.photo-preview {
  .user-avatar {
    @include background-cover;
    @include border-radius(100px);

    background-image: url('~@/assets/img/default-user.jpg');
    height: 80px;
    width: 80px;
    margin-right: 15px;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 15px;
  }
}

.logo {
  margin-bottom: 15px;
  text-align: center;

  img {
    max-width: 100%;
    height: 100px;
  }
}
</style>
